export class Banner {
    constructor(
        public id: number,
        public name: string,
        public image: string,
        public link: string,
        public norder:number,
        public date_created: Date,
    ) {}
}